/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect } from "react";
import EmployeeStepsContext from "../../../hooks/EmployeeStepsContext";
import DialogComponent from "../../../components/DialogComponent/DialogComponent";
import {
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Card,
  CardContent,
} from "@material-ui/core";
import styles from "../employee.module.scss";
import ConfirmCancel from "../../../components/DialogComponent/ConfirmCancel";
import { useMediaQuery } from "@mui/material";
import AuthContext from "../../../hooks/authContext";
import { Button } from "../../../components/ui/button";

const roles = [
  {
    name: "Team Admin",
    value: "Admin",
    description: "Full access to all pages, except Billing and Plans.",
  },
  {
    name: "Support",
    value: "Support",
    description: "Limited access: Dashboard, Operations, Communications, Reports.",
  },
  {
    name: "Guest",
    value: "Guest",
    description: "Restricted access - Communications, Reports.",
  },
  {
    name: "Client Team",
    value: "Client Team",
    description: "Mobile access only - field staff and similar employees.",
  },
];
const AssignGroup = (props) => {
  const stepsContext = React.useContext(EmployeeStepsContext);
  const {
    handleInputChange,
    companyEmployee,
    onCancelAll,
    finalLoading,
    isEdit,
    stepFormValues, 
    stepFormErrors
  } = props;
  const [selectedrole, setRole] = React.useState("Admin");
  const isMobile = useMediaQuery('(max-width:767px)');
  const auth = useContext(AuthContext);
  const companyId = auth?.userProfile?.role === "companyUser" ? auth?.userProfile?.id :auth?.userProfile?.companyId;
  const handleChangeRole = (event) => {
    const {
      target: { value },
    } = event;
    setRole(value);
    handleInputChange({ target: { name: "employeerole", value: value } });
  };

  useEffect(() => {
    setRole(stepFormValues?.employeerole);
  }, [stepFormValues?.employeerole]);

  return (
    <>
      <Card className={`${styles.cardProfile} dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]`}>
        <CardContent className="p-24">
            <div className="w-100">
              <h5 className="text-foreground" style={{fontSize:"20px", fontWeight:"600"}}>Select Role</h5>
              <div className="mt-12">
                <FormControl component="fieldset" className="w-100 dark:bg-[#1A1F2C]">
                  <RadioGroup
                    aria-label="role"
                    name="employeerole"
                    value={selectedrole ? selectedrole : ""}
                    onChange={handleChangeRole}
                  >
                    {roles?.map((role, index) => (
                      <div
                        key={role?.name + index}
                        style={{
                          // border: "1px solid hsl(214.3, 31.8%, 91.4%)",
                          borderRadius: "4px",
                        }}
                        className="mv-10 pl-8"
                      >
                        <FormControlLabel
                          className="w-100 dark:text-white"
                          value={role?.value}
                          control={<Radio color="primary" />}
                          label={
                            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                              <span style={{ fontWeight: 600 }}>{role?.name}</span>
                              <span style={{ fontSize: "13px", color: "#666" }}>
                                ({role?.description})
                              </span>
                            </div>
                          }
                          style={{ margin: 0, width: "100%" }}
                        />
                      </div>
                    ))}
                  </RadioGroup>
                  {typeof stepFormErrors?.employeerole !== "undefined" &&
                    stepFormErrors?.employeerole !== "" && (
                      <span className="small error color-danger">
                        {stepFormErrors?.employeerole}
                      </span>
                    )}
                </FormControl>
              </div>
          </div>
        </CardContent>
      </Card>
      {(!isEdit && companyEmployee) ? 
          <div className="d-flex flex-justify-center color-danger mb-20" style={{fontSize:"16px", fontWeight:"500"}}>
        You have reached the maximum number of users allowed on your plan. To add more users, please&nbsp;
        <a
          href="/account/upgrade"
          style={{
            color: "#16A34A",
            textDecoration: "underline",
            cursor: "pointer",
          }}
        >
          upgrade your plan.
        </a>
          </div>
      : null}
      <div className="buttonsWrap d-flex flex-space-between flex-center">
        <DialogComponent
          buttonWrapClassName="d-inline"
          buttonClassName="bg-white dark:bg-gray-800"
          buttonProps={{
          variant: "outline",
          disabled: finalLoading === true ? true : false,
          }}
          buttonLabel={"Cancel"}
          ModalTitle={"Are you sure you want to cancel this entry?"}
          ModalContent={
            <ConfirmCancel isEdit={isEdit} onCancelAll={onCancelAll} />
          }
        />
        <Button
          variant={"contained"}
          className="bg-green-600 hover:bg-green-700 color-white"
          onClick={() => props?.validateAndGoNext()}
          disabled={(!isEdit && companyEmployee) || finalLoading === true ? true : false}
        >
          {finalLoading === true ? "Loading..." : "Save & Proceed"}
        </Button>
      </div>
    </>
  );
};

export default AssignGroup;
